import { render, staticRenderFns } from "./HistoryScrollList.vue?vue&type=template&id=a2001f5e&scoped=true"
import script from "./HistoryScrollList.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryScrollList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoryScrollList.vue?vue&type=style&index=0&id=a2001f5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2001f5e",
  null
  
)

export default component.exports